/**
 * Form Field Defaults
 * 
 * Provides default field components for different media types in editor and generator modes.
 */
import { MediaType } from '../../core/template.schemas';
import { FieldToken } from './media/mediaRegistry';

/**
 * Default field components for each media type
 */
export const formFieldDefaults: Record<MediaType, { editor: FieldToken; generator: FieldToken }> = {
  text: { editor: 'TextInput', generator: 'TextInput' },
  image: { editor: 'ImagePicker', generator: 'ImagePicker' },
  date: { editor: 'DatePicker', generator: 'DatePicker' },
  color: { editor: 'ColorPicker', generator: 'ColorPicker' },
  int: { editor: 'NumberInput', generator: 'NumberInput' },
  float: { editor: 'NumberInput', generator: 'NumberInput' },
};